import * as Web from '/js/lib/webact.js';

class PageLinks extends Web.Component {
  constructor () {
    super(import.meta.url);
  }

  async componentDidMount () {
    const assignedNodes = this.$('slot').assignedNodes();
    const currentPageLink = assignedNodes.find(el => el.classList ? el.classList.contains('current') : false);

    if (currentPageLink instanceof HTMLElement) {
      // currentPageLink.scrollIntoView({ inline: 'center' });
      const boundingRect = currentPageLink.getBoundingClientRect();

      this.scrollLeft = boundingRect.left - boundingRect.width - this.offsetLeft;
    }
  }
}

export default Web.registerComponent(PageLinks, {
  name: 'page-links'
});
